var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["macros/ugc-tile-macro.j2"] = require( "macros/ugc-tile-macro.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/contentful/ugc-module.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("macros/ugc-tile-macro.j2", false, "core/templates/contentful/ugc-module.j2", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(context.getVariables(), frame, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
if(t_1.hasOwnProperty("displayUgcTile")) {
var t_4 = t_1.displayUgcTile;
} else {
cb(new Error("cannot import 'displayUgcTile'")); return;
}
context.setVariable("displayUgcTile", t_4);
output += "\n\n";
if((lineno = 3, colno = 8, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["product",false]))) {
output += "<div class=\"c-ugc s-ugc-pdp\">";
;
}
else {
output += "<div class=\"c-ugc\">";
;
}
output += "<div class=\"dom-ugc js-ugc\" data-qa-ugc=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "multipleIndex"), env.opts.autoescape);
output += "\" data-index=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "multipleIndex"), env.opts.autoescape);
output += "\"></div>\n</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/contentful/ugc-module.j2"] , dependencies)